import React from "react";

import { isEmpty } from "ramda";

import { Pagination, Table } from "components/Common/clearsense-ui/components";
import NoData from "components/Common/NoData";

const BusinessTermsTable = ({
  businessTerms,
  columns,
  filterParams,
  businessTermsCount,
  setIsPaneOpen,
  userPermissions,
}) => {
  const {
    debouncedSearchTerm,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
  } = filterParams;

  if (!businessTermsCount && isEmpty(debouncedSearchTerm)) {
    return (
      <NoData
        entity="business terms"
        actionLabel="Associate Business Terms"
        onAction={() => setIsPaneOpen(true)}
        currentPermissions={userPermissions}
        acceptablePermissions="associate"
      />
    );
  }

  return (
    <div className="flex flex-col flex-grow mt-8">
      <Table
        rowData={businessTerms}
        columnData={columns.selected}
        rowKey={record => record.id}
      />
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        showResultsPerPage
        totalRecordsCount={businessTermsCount}
        className="p-2 mt-auto"
      />
    </div>
  );
};

export default BusinessTermsTable;
